import React, { useEffect, useState } from "react";
import { Card, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow, Chip } from "@material-ui/core";
import { Button, IconButton, InputBase, Paper, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery, Divider, Box } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useQuery } from 'react-query';
import { NGO } from "src/api/axios";
import UserListHead from "src/components/user/UserListHead";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import Stack from '@mui/material/Stack';
import { useSnackbar } from "notistack";
import { useTheme } from '@mui/material/styles';
import SearchIcon from "src/svgComponents/SearchIcon";
import LoadingScreen from "src/components/LoadingScreen";
import moment from "moment";
const _ = require('lodash');

const CharityTransaction = () => {
    const [tableData, setTableData] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');
    const axiosPrivate = useAxiosPrivate();
    const [showImage, setShowImage] = useState();
    const [filterName, setFilterName] = useState('');
    const { enqueueSnackbar } = useSnackbar();
    const [deleteId, setdeleteId] = useState("");
    const [open, setOpen] = useState(false);
    const theme = useTheme();
    const [loding, setLoding] = useState(true);
    const [totalOrderAmount, setTotalOrderAmount] = useState();
    const [totalPendingPayout, setTotalPendingPayout] = useState();
    const [totalConfirmedPayout, setTotalConfirmedPayout] = useState();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: '#ffffff',
        },
        '&:nth-of-type(even)': {
            background: "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), #F4F5F7",
        },
        // hide last border
        '& td, & th': {
            border: 0,
        },
    }));

    const TABLE_HEAD = [
        { id: 'title', label: 'Title', alignRight: false },
        { id: 'sub_title', label: 'Sub Title', alignRight: false },
        { id: 'image', label: 'Image', alignRight: false },
        { id: 'amount', label: 'Donation Amount', alignRight: false },
        { id: 'transaction_msg', label: 'Transaction Message', alignRight: false },
        { id: 'transaction_id', label: 'Transaction Id', alignRight: false },
        { id: 'userName', label: 'Username', alignRight: false },
        { id: 'email', label: 'Email', alignRight: false },

        // { id: 'action', label: 'Action', alignRight: false },
    ];

    async function getCharityTransactionList(page, filterName) {
        const response = await axiosPrivate.get(NGO.getCharityTransactionList, { params: { page: page + 1, search: filterName, limit: rowsPerPage } })
        return response.data[0];
    }

    const { data: CharityTransactionList, refetch } = useQuery(['CharityTransactionList', page, filterName], () => getCharityTransactionList(page, filterName), { keepPreviousData: true, })

    useEffect(() => {
        if (CharityTransactionList) {
            setTableData(CharityTransactionList.data);
            setRowsPerPage(CharityTransactionList?.metadata.length != 0 ? CharityTransactionList?.metadata[0].limit : 10);
        }
        if (CharityTransactionList?.metadata.length != 0 && CharityTransactionList?.metadata[0].hasMoreData == true) {
            getCharityTransactionList(page + 1);
        }
        setLoding(false);
    }, [CharityTransactionList])

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setTimeout(() => {
            refetch();
        }, 500);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleFilterByName = (event) => {
        setFilterName(event.target.value.trim());
        setPage(0);
        getCharityTransactionList(page, filterName)
        refetch();
    };

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }
    function applySortFilter(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });

        return stabilizedThis.map((el) => el[0]);
    }

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const filteredUsers = applySortFilter(tableData, getComparator(order, orderBy));

    const handleClose = () => {
        setOpen(false);
        setShowImage('');
    };

    const deleteOrder = async () => {
        const response = await axiosPrivate.delete(NGO.deleteOrder + deleteId)
        if (response.status == 200) {
            enqueueSnackbar("Order delete successfully", {
                variant: "success",
                anchorOrigin: { vertical: "top", horizontal: "right" },
                autoHideDuration: 2000,
            });
        } else {
            enqueueSnackbar("something went wrong", {
                variant: "error",
                anchorOrigin: { vertical: "top", horizontal: "right" },
                autoHideDuration: 2000,
            });
        }
        refetch();
        handleClose();
    };

    return (
        <Box>
            {loding ? <LoadingScreen /> : <>
                <div className="dashboard_header mb-4">
                    <h4 className="app_text_20_semibold mb-0 d-flex align-items-center">Charity Transaction</h4>
                    <Paper component="form" className='dashboard_searchbox col-lg-4'>
                        <IconButton>
                            <SearchIcon />
                        </IconButton>
                        <InputBase
                            fullWidth
                            sx={{ flex: 1 }}
                            placeholder="search ..."
                            onChange={(e) => handleFilterByName(e)}
                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                        />
                    </Paper>
                </div>
                <Card>
                    <TableContainer>
                        <Table>
                            <UserListHead
                                headLabel={TABLE_HEAD}
                                rowCount={CharityTransactionList?.data?.length}
                                onRequestSort={handleRequestSort}
                            />
                            {filteredUsers?.length > 0 ?
                                <TableBody>
                                    {filteredUsers.map((row) => {
                                        return (
                                            <StyledTableRow key={row._id}>
                                                <TableCell align="left"> {row?.charity_event_data.title} </TableCell>
                                                <TableCell align="left"> {row?.charity_event_data.sub_title} </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <img src={process.env.REACT_APP_PROFILE_URL + 'ngoItems/' + row.charity_event_data.image} height="50px" alt="profile" />
                                                </TableCell>
                                                <TableCell align="left"> £{row?.amount?.toFixed(2)} </TableCell>
                                                <TableCell align="left"> {row?.transaction_msg ?? '-'} </TableCell>
                                                <TableCell align="left"> {row?.transaction_id ? row?.transaction_id : '-'} </TableCell>
                                                <TableCell align="left"> {row?.user_data.userName} </TableCell>
                                                <TableCell align="left"> {row?.user_data.email} </TableCell>
                                                {/* <TableCell>
                                       <Stack direction="row" spacing={3}>
                                          <Button title="Order Details" variant="text" className="user_list_row_btn" onClick={(e) => handleViewDetail(row)} ><VisibilityIcon /></Button>
                                          {permissionsData?.order?.substring(2, 3) == "1" ?
                                             <Button title="Order Delete" variant="text" className="user_list_row_btn" onClick={() => handleClickOpen(row._id, "main")} ><BinIcon /></Button>
                                             : ""}
                                       </Stack>
                                    </TableCell> */}
                                            </StyledTableRow>
                                        )
                                    })}
                                </TableBody>
                                :
                                <TableBody>
                                    <TableRow>
                                        <TableCell align="center" colSpan={9} sx={{ py: 5 }}>
                                            <span className="app_text_16_semibold">No Data Found</span>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>}
                        </Table>
                    </TableContainer>
                    <TablePagination
                        component="div"
                        rowsPerPageOptions={[10, 20, 50, 100]}
                        count={CharityTransactionList?.metadata.length != 0 ? CharityTransactionList?.metadata[0].total : 0}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Card>
            </>
            }
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title" className='m-auto'>
                    {"are you sure you want to delete?"}
                </DialogTitle>
                <DialogContent>
                </DialogContent>
                <DialogActions className='m-auto'>
                    <Button className="theme_button_view" variant="contained" autoFocus onClick={handleClose}>
                        cancel
                    </Button>
                    <Button className="theme_button" variant="contained" onClick={() => deleteOrder()} autoFocus>
                        delete
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

export default CharityTransaction